import Link from "next/link";

import type { ChatController } from "~/hooks/useChatController";
import useGlobalStore from "~/hooks/useGlobalStore";
import { getRoutePrefix } from "~/utils/helpers";

interface ChatContentSubtitleProps {
	controller: ChatController;
}

/**
 * Shows which content item the conversation is connected to: the thread's
 * hydrated content once it exists, or the current page for a new chat.
 */
const ChatContentSubtitle = ({ controller }: ChatContentSubtitleProps) => {
	const { chatPageContent } = useGlobalStore();
	const { thread, activeChatThreadId } = controller;

	if (thread?.content) {
		const { type, title, slug } = thread.content;

		return (
			<Link
				href={`/${getRoutePrefix(type)}/${slug}`}
				className="line-clamp-1 min-w-0 text-left text-slate-500 text-xs transition-colors hover:text-slate-700 hover:underline dark:text-slate-400 dark:hover:text-slate-200"
			>
				{title}
			</Link>
		);
	}

	if (activeChatThreadId === null && chatPageContent) {
		return (
			<span className="line-clamp-1 min-w-0 text-left text-slate-500 text-xs dark:text-slate-400">
				{chatPageContent.title}
			</span>
		);
	}

	return null;
};

export default ChatContentSubtitle;
